import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type StoreInfo as SchemaStoreInfo } from '../schemas/StoreInfo';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary get store info
 */
export const GetStoreInfoContentType = '' as const;
export type GetStoreInfoRequest = void;
export type GetStoreInfoResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaStoreInfo;
    };
};
export type GetStoreInfoResponseSuccess = GetStoreInfoResponses['200']['application/json'];
export type GetStoreInfoSearchParams = undefined;
export type GetStoreInfoPathParameters = undefined;
export const GetStoreInfoUrl = '/store/info' as const;
export const GetStoreInfoMethod = 'GET' as const;
export const getGetStoreInfoUrl = (_params?: GetStoreInfoPathParameters) => GetStoreInfoUrl;
